// extracted by mini-css-extract-plugin
export default {"root":"CloseIcon_root__MNutF","text":"CloseIcon_text__y-dLg","icon":"CloseIcon_icon__8hpd9"};